export default "__VITE_ASSET__BhqXlU_3__"